module.exports = __webpack_public_path__ + "img/main.6ff5fdfa.png";